import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import OvTimeSummaryTable from "./OvTimeSummaryTable";

import moment from "moment";

const OvTimeInfoContent = props => {
  const { granularity, data } = props;

  const renderFilterString = () => {
    const { filterState } = props;
    const account = filterState.account.selected.text;

    let str = "Displaying usage data for ";
    str += account ? `account: ${account}` : "all accounts";
    return str;
  };

  const renderDateRange = () => {
    const len = data.length;
    if (len === 0) {
      return (
        <span style={{ color: "red" }}>No data in the requested period</span>
      );
    }
    const first = moment.utc(data[0].timestamp);
    const last = moment.utc(data[len - 1].timestamp);

    return `Actual range: ${first.format(
      "Do MMM YYYY, HH:00 a"
    )} - ${last.format("Do MMM YYYY, HH:00 a")}`;
  };

  const renderGranularity = () => {
    return `Granularity: ${granularity.count} ${granularity.unit}`;
  };

  const renderNumDataPoints = () => {
    return `Number of data points: ${data.length}`;
  };

  return (
    <div>
      <Typography component="p">{renderFilterString()}</Typography>
      <Typography component="p">{renderDateRange()}</Typography>
      <Typography component="p">{renderGranularity()}</Typography>
      <Typography component="p">{renderNumDataPoints()}</Typography>
      <OvTimeSummaryTable data={data} />
    </div>
  );
};

OvTimeInfoContent.propTypes = {
  granularity: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired
};

export default OvTimeInfoContent;



// WEBPACK FOOTER //
// ./src/OvTimeInfoContent.js